module.exports = __webpack_public_path__ + "img/al2.d9697d13.png";